import gql from 'graphql-tag';

const NEW_UPDATE_SECURITY_CONFIGURATION = gql`
  mutation($configurationId: ID!, $input: AppSecurityConfigurationInput) {
    updateAppSecurityConfiguration(
      configurationId: $configurationId
      input: $input
    ) {
      configurationId
      sessionInactiveDuration
      sessionInactiveUnit
      sessionTrustEnable
      ipWhitelistEnable
      ipWhitelistRange
      companyUserPasswordPolicy
      clientUserPasswordPolicy
      companyUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      clientUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      enforceTfa
    }
  }
`;

const UPDATE_SECURITY_CONFIGURATION = gql`
  mutation(
    $configurationId: ID!
    $ssoType: String
    $idpDetail: IdpSamlProviderDetailInput
    $sessionInactiveDuration: Int
    $sessionInactiveUnit: String
    $sessionTrustEnable: Boolean
    $ipWhitelistEnable: Boolean
    $ipWhitelistRange: String
    $companyUserPasswordPolicy: String
    $clientUserPasswordPolicy: String
    $companyUserCustomPasswordPolicy: PasswordPolicyInput
    $clientUserCustomPasswordPolicy: PasswordPolicyInput
    $enforceTfa: Boolean
  ) {
    updateAppSecurityConfiguration(
      configurationId: $configurationId
      input: {
        ssoType: $ssoType
        idpDetail: $idpDetail
        sessionInactiveDuration: $sessionInactiveDuration
        sessionInactiveUnit: $sessionInactiveUnit
        sessionTrustEnable: $sessionTrustEnable
        ipWhitelistEnable: $ipWhitelistEnable
        ipWhitelistRange: $ipWhitelistRange
        companyUserPasswordPolicy: $companyUserPasswordPolicy
        clientUserPasswordPolicy: $clientUserPasswordPolicy
        companyUserCustomPasswordPolicy: $companyUserCustomPasswordPolicy
        clientUserCustomPasswordPolicy: $clientUserCustomPasswordPolicy
        enforceTfa: $enforceTfa
      }
    ) {
      ssoType
      idpDetail {
        certificate
        idpLoginUrl
        postLogoutUrl
      }
      sessionInactiveDuration
      sessionInactiveUnit
      sessionTrustEnable
      ipWhitelistEnable
      ipWhitelistRange
      companyUserPasswordPolicy
      clientUserPasswordPolicy
      companyUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      clientUserCustomPasswordPolicy {
        length
        isAlphaNumeric
        isMixCaseWithSpecialChar
        checkEmailMatch
        checkPrevPasswordMatchCount
        allowedFailureAtempt
        passwordExpiryDays
      }
      enforceTfa
    }
  }
`;

const CREATE_SSO_CONFIGURATION = gql`
  mutation($scope: String, $userType: String, $input: SSOConfigurationInput) {
    createSsoConfiguration(scope: $scope, userType: $userType, input: $input) {
      configId
      name
      userType
      scope
      clients {
        accountId
        name
      }
      enabled
      entityId
      idpLoginUrl
      certificate
      idpLogoutUrl
      createdBy {
        name
      }
      updatedBy {
        name
      }
    }
  }
`;

const UPDATE_SSO_CONFIGURATION = gql`
  mutation(
    $configurationId: ID!
    $scope: String
    $userType: String
    $input: SSOConfigurationInput
  ) {
    updateSsoConfiguration(
      configurationId: $configurationId
      scope: $scope
      userType: $userType
      input: $input
    ) {
      configId
      name
      userType
      scope
      clients {
        accountId
        name
      }
      enabled
      entityId
      idpLoginUrl
      certificate
      idpLogoutUrl
      createdBy {
        name
      }
      updatedBy {
        name
      }
    }
  }
`;

const DELETE_SSO_CONFIGURATION = gql`
  mutation($configurationId: ID!) {
    deleteSsoConfiguration(configurationId: $configurationId)
  }
`;

export {
  UPDATE_SECURITY_CONFIGURATION,
  NEW_UPDATE_SECURITY_CONFIGURATION,
  CREATE_SSO_CONFIGURATION,
  UPDATE_SSO_CONFIGURATION,
  DELETE_SSO_CONFIGURATION
};
